__turbopack_context__.v({
  "className": "dm_sans_fc2cd777-module__Ys_QSa__className",
});
